export default {
  init() {
    const mapEl = $('.auction-map');
    if (mapEl) {
      this.renderMap(mapEl);
    }
  },

  renderMap(mapEl) {
    let pos = {
      lat: parseFloat(mapEl.data('lat')),
      lng: parseFloat(mapEl.data('lng')),
    };

    let map = new window.google.maps.Map(mapEl[0], {
      center: pos,
      disableDefaultUI: true,
      zoomControl: true,
      zoom: 13,
    });

    this.addMarker(pos, map);
  },

  addMarker(pos, map) {
    return new window.google.maps.Marker({
      position: pos,
      map,
      animation: window.google.maps.Animation.DROP,
      clickable: false,
    });
  },
};
